import { QuietButton } from "features/shared/components/buttons/QuietButton.styled";
import styled from "styled-components";

const StyledMxCitizenshipProofPage = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 16px;

  ${QuietButton} {
    width: 100%;
  }

  @media all and (max-width: ${({ theme }) => theme.mobileBreakingPoint}) {
    display: block;
  }
`;

export default StyledMxCitizenshipProofPage;
